<script setup>
  import { TriangleAlert } from "lucide-vue-next";
  import { Tooltip } from "@/components/ui/tooltip";

  defineProps({
    errors: { type: Object, default: () => ({}) },
    cardName: { type: String, default: "" },
  });
</script>
<template>
  <Tooltip>
    <template #content>
      <span
        v-for="(error, i) in errors"
        :key="i"
        >⸱ {{ error }}<br />
      </span>
    </template>
    <TriangleAlert class="size-5 shrink-0 text-status-error" />
  </Tooltip>
</template>
